import React from "react";
import {
  AppBar,
  Box,
  IconButton,
  LinearProgress,
  Toolbar,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

const SetupProgress = ({ eventName, stepNumber, total, onBack }) => {
  const { t } = useTranslation();
  const percent = total > 0 ? ((stepNumber - 1) / total) * 100 : 0;

  return (
    <AppBar position="sticky" color="default" elevation={0}>
      <Toolbar sx={{ minHeight: 56 }}>
        <IconButton
          edge="start"
          onClick={onBack}
          disabled={!onBack}
          sx={{ visibility: onBack ? "visible" : "hidden" }}
          aria-label="back"
        >
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {eventName || t("setup.fallback.title")}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t("setup.step", { current: stepNumber, total })}
          </Typography>
        </Box>
      </Toolbar>
      <LinearProgress variant="determinate" value={percent} />
    </AppBar>
  );
};

export default SetupProgress;
